import { useGetList, useTranslate } from "ra-core";

import type { AgreementCheck, FirstOrder } from "./agreementData";

export type Signal = { id: string; agreementId: number; text: string };

// "Segnalazioni" of the Today screen (task 1.10, D-039): agreements of the
// person expiring and first orders overdue. The pool goes only on the
// agreement pages.
export const useAgreementSignals = (salesId?: number): Signal[] => {
  const translate = useTranslate();
  const params = {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "id", order: "ASC" as const },
  };
  const { data: expiring = [] } = useGetList<
    AgreementCheck & { title: string }
  >(
    "agreement_checks",
    { ...params, filter: { sales_id: salesId, is_expiring: true } },
    { enabled: salesId != null },
  );
  const { data: overdue = [] } = useGetList<FirstOrder & { title: string }>(
    "agreement_first_order",
    { ...params, filter: { sales_id: salesId, is_overdue: true } },
    { enabled: salesId != null },
  );
  return [
    ...expiring.map((item) => ({
      id: `expiring:${item.id}`,
      agreementId: Number(item.id),
      text: translate("tenax.agreements.signals.expiring", {
        title: item.title,
      }),
    })),
    ...overdue.map((item) => ({
      id: `first_order:${item.id}`,
      agreementId: Number(item.id),
      text: translate("tenax.agreements.signals.first_order_overdue", {
        title: item.title,
      }),
    })),
  ];
};
